import { useCallback, useEffect } from 'react'

import { useTranslation } from 'react-i18next'

import { PublicOfferApi } from 'shared/api/PublicOfferApi'
import { PublicOfferModel } from 'shared/api/PublicOfferModel'
import { useRequest } from 'shared/hooks/use-request'
import { getErrorMessage } from 'shared/lib/errorText'
import { previewPdfUrl } from 'shared/lib/pdf-preview'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types'
import { EmptyPage } from 'shared/ui/empty-page'
import { HeaderGoBack } from 'shared/ui/header-go-back'
import { SimpleLoader } from 'shared/ui/simple-loader'

import s from './styles.module.scss'

const Offers = () => {
  const { t } = useTranslation()
  const {
    data: offers,
    error,
    isLoading,
    run,
  } = useRequest<PublicOfferModel[]>()
  const errorText =
    error === null ? null : getErrorMessage(error) || t('error_des')

  const loadOffers = useCallback(
    () =>
      run(async (signal) => {
        const { data: response } = await PublicOfferApi.getOffers(signal)

        return response.data
      }),
    [run],
  )

  useEffect(() => {
    void loadOffers()
  }, [loadOffers])

  return (
    <div className="container">
      <div className={s.wrapper}>
        <HeaderGoBack
          buttonWhite
          variant="grey"
          title={t('public_offer')}
        />

        <div className={s.list}>
          {isLoading ? (
            <SimpleLoader />
          ) : errorText ? (
            <EmptyPage
              title={t('error')}
              subTitle={errorText}
              buttonText={t('try_again')}
              onClick={() => void loadOffers()}
            />
          ) : (
            offers?.map((offer) => (
              <button
                key={offer.key}
                type="button"
                className={s.item}
                onClick={() => previewPdfUrl(offer.file)}
              >
                <span className={`regular-16 ${s.itemTitle}`}>
                  {offer.name}
                </span>
                <span
                  className={s.chevron}
                  aria-hidden="true"
                >
                  <AppIcon
                    id={AllIcons.ARROW_RIGHT}
                    height={20}
                    width={20}
                    color="var(--grey-3)"
                  />
                </span>
              </button>
            ))
          )}
        </div>
      </div>
    </div>
  )
}

export default Offers
